import { Logic, Operator } from 'core-components/types'

import { getJbpHpContactsCrud } from '../lib'

interface IParams {
  partnerId: string
  email: string
  isForce?: boolean
}

export const getContactsByEmail = async ({ partnerId, email, isForce = false }: IParams) => {
  const crud = getJbpHpContactsCrud('contacts-by-email')

  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'PartnerId',
        operator: Operator.EQUAL,
        value: partnerId,
      },
      {
        field: 'Email',
        operator: Operator.EQUAL,
        value: email,
      },
    ],
  })

  const response = await crud.fetch({ force: isForce })

  return response.items
}
